<template>
  <el-dialog
    :title="model.category_id == 1 ? '发货单出库' : '普通出库'"
    :visible.sync="visible"
    width="1000px"
    @close="$emit('update:show', false)"
  >
    <el-form :model="model" :rules="rules" ref="form" label-width="100px" size="small">
      <el-form-item label="发货单单号" v-if="model.category_id == 1" prop="shipping_record_id">
        <el-select
          style="position: relative"
          size="small"
          class="fix-width"
          placeholder="请选择"
          v-model="model.shipping_record_id"
          :disabled="model.init_order"
        >
          <el-option
            v-for="item in records"
            :key="item.id"
            :label="item.number"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>

        <!-- <div
          class="panel"
          style="position: absolute; top: 0; left: 300px; width: 400px; z-index:1"
          v-if="order"
        >
          <div class="header">
            <h2>出库清单</h2>
          </div>
          <ul class="item-list">
            <template v-for="device in order.quotation.devices">
              <li class="flex-row-between" v-for="item in device.items">
                <span>{{ item.item.name }}</span>
                <span>x{{ item.count }}</span>
              </li>
            </template>
          </ul>
        </div>-->
      </el-form-item>

      <el-form-item label="申请人" prop="applicant_id">
        <el-select size="small" class="fix-width" placeholder="请选择" v-model="model.applicant_id">
          <el-option
            v-for="item in users"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="经办人">
        <el-select size="small" class="fix-width" placeholder="请选择" v-model="model.transactor_id">
          <el-option
            v-for="item in users"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出库时间" prop="stock_out_date">
        <el-date-picker
          v-model="model.stock_out_date"
          size="small"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item class="list" label="产品明细" prop="items">
        <el-table
          v-if="model.items && model.items.length > 0"
          :data="model.items"
          header-row-class-name="customer-mini-header"
        >
          <el-table-column label="对象" width="60px">
            <template slot-scope="scope">{{scope.row.item.category == 1 ? "零件" : "设备"}}</template>
          </el-table-column>
          <el-table-column align="center" label="名称" width="150px">
            <template slot-scope="scope">{{scope.row.item.name}}</template>
          </el-table-column>
          <el-table-column align="center" prop="stockroom.name" label="仓库" width="80px"></el-table-column>
          <el-table-column align="center" prop="item.part_number" label="件号" width="135px"></el-table-column>
          <el-table-column align="center" label="机型" width="135px">
            <template slot-scope="scope">{{scope.row.item.machine_type}}</template>
          </el-table-column>
          <el-table-column align="center" label="单价" width="100px">
            <template slot-scope="scope">
              <el-input-number
                style="width: 80px"
                :controls="false"
                size="mini"
                v-model="scope.row.price"
                :disabled="model.category_id == 1"
                :precision="2"
                :min="0"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column align="center" label="数量" width="120px">
            <template slot-scope="scope">
              <el-input-number
                style="width: 100px"
                size="mini"
                type="number"
                v-model="scope.row.number"
                :disabled="model.category_id == 1"
                :min="1"
                :max="scope.row.max"
                label
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column width="80">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="text-danger"
                @click="removeItem(scope.$index)"
                v-if="model.category_id != 1"
              >删除</el-button>
              <el-button
                type="text"
                class="text-danger"
                v-else
              >{{scope.row.stockroom_id > 0 ? '' : '库存不足'}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="itemSelectorVisible = true"
          v-if="model.category_id != 1"
        >添加</el-button>
      </el-form-item>
      <el-form-item label="物流单号">
        <el-input
          v-model="model.express_number"
          class="fix-width"
          size="small"
          placeholder="请输入物流单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="物流公司">
        <el-input
          v-model="model.express_company"
          class="fix-width"
          size="small"
          placeholder="请输入物流公司"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="model.remark"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 8}"
          class="fix-width"
          size="small"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm">确 定</el-button>
    </div>

    <item-device-selector
      :show.sync="itemSelectorVisible"
      :selection="model.items"
      :inner="true"
      @selected="doneSelectedItems"
    ></item-device-selector>
  </el-dialog>
</template>

<script>
import ItemDeviceSelector from '@/components/item_device_out_selector'
import {
  createStockOutBill,
  updateStockOutBill,
  userList,
  selectStoreItemList,
} from '@/service/getData'

export default {
  components: {
    ItemDeviceSelector,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    'model.shipping_record_id': 'getShippingRecordInfo',
  },
  created() {
    this.initData()
  },
  data() {
    return {
      itemSelectorVisible: false,
      visible: this.show,
      users: [],
      record: null,
      records: [],
      rules: {
        stock_out_date: [{ required: true, message: '请选择出库时间' }],
        applicant_id: [{ required: true, message: '请选择申请人' }],
        items: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个产品',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    async initData() {
      let res = await userList({
        page: 0,
        size: 1000,
        resource_not_filter: true,
      })
      this.users = res.data.list
    },
    // async getShippingRecordList() {
    //   let res = await shippingRecordList({
    //     page: 0,
    //     size: 2000,
    //     stock_out_bill_id: 0,
    //   })
    //   this.records = res.data.list
    // },
    async getShippingRecordInfo() {
      if (this.model.shipping_record_id) {
        let itemIDs = this.model.items.map((i) => {
          return parseInt(i.item.id)
        })

        let itemIDstring = itemIDs.join('&item_ids=')
        let res = await selectStoreItemList({
          item_ids: itemIDstring,
        })
        let store_items = res.data.list
        this.model.items.map((it) => {
          let stockroom = { name: '-', id: 0 }
          if (store_items) {
            let store_item = store_items.filter(
              (s) => s.item_id == it.item.id && s.count >= it.number
            )
            if (store_item.length > 0) {
              stockroom = store_item[0].stockroom
            }
          }

          this.$set(it, 'stockroom', stockroom)
          this.$set(it, 'stockroom_id', stockroom.id)
        })
        this.records = [
          {
            id: this.model.shipping_record_id,
            number: this.model.shipping_record_number,
          },
        ]
      }
    },
    doneSelectedItems(items) {
      this.model.items = this.model.items.concat(items)
      this.model.items.map((v) => {
        this.$set(v, 'number', 1)
        this.$set(v, 'price', v.item.price)
      })
      this.$refs.form.validateField('items')
    },
    removeItem(index) {
      this.model.items.splice(index, 1)
    },
    formatData(obj) {
      const keys = ['applicant_id', 'transactor_id', 'shipping_record_id']
      for (let key in obj) {
        if (keys.indexOf(key) != -1 && obj[key] == '') {
          obj[key] = 0
        }
      }
      return obj
    },
    submitForm() {
      if (
        this.model.items.filter((item) => item.stockroom.id == 0).length > 0
      ) {
        this.$message({
          message: '提交失败，存在库存不足产品',
          type: 'error',
          center: true,
        })
        return
      }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.formatData(this.model)
          if (this.model.id > 0) {
            let res = await updateStockOutBill(data)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createStockOutBill(data)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
<style scoped>
.fix-width {
  width: 220px;
}
</style>>